import FormItem from './FormItem'

export default {
  props: {
    value: {
      type: [File, String, Number, Boolean, Array, Object, Date],
      default: null
    },

    label: {
      type: String,
      default: null
    },

    validator: {
      type: Object,
      default: null
    }
  },

  components: { FormItem },

  computed: {
    val: {
      get () {
        return this.value
      },
      set (val) {
        if (this.validator) {
          this.validator.$touch()
        }
        this.$emit('input', val)
      }
    }
  },
}